import { Component, OnInit } from '@angular/core';
import { DevedorService } from '../../services';
import { ActivatedRoute } from '@angular/router'; 
import { Subscription } from 'rxjs';
import { DetalheBaseController } from '../../helpers';

@Component({
    templateUrl: 'ouvirligacao.component.html'
})

export class OuvirLigacaoComponent extends DetalheBaseController {
    
    ligacoes: any = [];    
    subLigacao: Subscription;   

    constructor(route: ActivatedRoute, private _devedorService: DevedorService) {
        super(route, _devedorService);          
    }

    ngOnInit(){
        this.getlistaAudios(0); 
    }

    getlistaAudios(devedorid: any) {
        this._loading.carregar();
        this.subLigacao = this._devedorService.getlistaAudios(devedorid).subscribe(result => {
        this._loading.fecharTodos();
        this.ligacoes = result; 
        this.showForm = true; 
        });
    }

    voltar =()=> this._location.back();    
    
    ngOnDestroy() {
        if (this.subLigacao) this.subLigacao.unsubscribe();            
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/audio/ouvirligacao.component.ts